export const SEARCH_FORM_QA_ID = 'shared-searchForm';
export const HEADER_QA_ID = 'shared-header';
export const FOOTER_QA_ID = 'shared-footer';
export const TRAVEL_DETAILS_OVERLAY_QA_ID = 'shared-travel-details-overlay';
export const ALTERNATIVE_TRAVEL_FORM_QA_ID = 'shared-alternativeTravelForm';
export const FLIGHT_DETAILS_QA_ID = 'shared-flightDetails';
export const HOTEL_DETAILS_QA_ID = 'shared-hotelDetailsOverlay';
export const OFFER_DETAILS_QA_ID = 'shared-offerDetails';
export const NPS_FEEDBACK_QA_ID = 'shared-feedback';
export const PRICE_OVERVIEW_QA_ID = 'shared-priceOverview';
export const A3M_BANNER_QA_ID = 'shared-a3mBanner';
export const TOUR_OPERATOR_SPECIAL_QA_ID = 'shared-tourOperatorSpecial';
export const AUTHENTICATION_QA_ID = 'shared-authentication';
export const SCARCITY_ELEMENT_QA_ID = 'shared-scarcityElement';
export const qaId = (...ids) => ids.reduce((a, b) => `${a}-${b}`);